<template>
  <div class="timespan" :class="customClass">
    <input type="number" :value="value" @change="updateValue" placeholder="不限制" />
    <dropdown-select
      :optionGroups="[{ options: allowedTimeUnit }]"
      customClass="transparent"
      :initValue="unit || allowedTimeUnit[0]"
      @change="unitChangeFunc"
    >
      <template #value-template="{ option }">
        <span>{{ zhUnit(option) }}</span>
      </template>
      <template #option-template="{ option }">
        <span>{{ zhUnit(option) }}</span>
      </template>
    </dropdown-select>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js'
import TimeSpanMixin from 'trunks/vue/share/mixins/time_span.js'

export default defineComponent({
  name: 'TimeSpan',
  mixins: [TimeSpanMixin],
  emits: ['valueChanged'],
  components: {
    'dropdown-select': DropdownSelect
  },
  methods: {
    zhUnit(option) {
      return Skylark.Helpers.getZH_CN('date.unit.' + option)
    }
  }
})
</script>
